export const DEFAULT_VARIANT = 'contained';
export const DEFAULT_SIZE = 'medium';
export const DEFAULT_COLOR = 'primary';
